export default Object.freeze({
  ALL: 'all',
  SELECTED: 'selected',
  NO_SELECTED: 'noselected',
});
